import styled from "styled-components";

export const StarRatingWrapper = styled.div`
    margin: 0 0 0 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
`;

export const StarButton = styled.button`
    background-color: transparent;
    border: none;
    margin: 0;
    padding: 0;
    outline: none;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;

    & svg path {
        fill: rgba(169, 169, 169, 0.4); 
        transition: all 0.3s ease-out;
    }

    &.active {
        & svg path {
            fill: #FFD700;
            transition: all 0.3s ease-out;
        }
    }

    &.inactive {
        & svg path {
            fill: rgba(169, 169, 169, 0.4); 
            transition: all 0.3s ease-out;
        }
    }
`;
